import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { images } from "../../../../Assets/assetsHelper";
import "./TeamsDetails.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarLoader } from "react-spinners";
import DeleteForm from "../../../../Components/Molecules/DeleteForm/DeleteForm";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import {
  BaseURL,
  mcqTeamSubmissionURL,
  missionsURL,
} from "../../../../Hooks/URL";
import useDelete from "../../../../Hooks/useDelete";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    padding: 8,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 8,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const MissionItem = ({
  item,
  team,
  setSubmissionStatus,
  setGoEdit,
  submissionStatus,
}) => {
  const navigate = useNavigate();
  const [goDelete, setGoDelete] = useState(false);
  const { deleteRes: deleteSubmission } = useDelete(
    `${mcqTeamSubmissionURL}/${item?.submission?.id}`,
    goDelete,
    null,
    null,
    null,
    {},
    true
  );
  return (
    <Grid item xs={12} md={6} lg={4}>
      <Box className="missionInfoSection">
        <div className="missionSettingsHeader">
          <h3 className="missionSettingsTitle">{item?.name}</h3>
        </div>
        <Grid container spacing={1}>
          {/* Basic Information */}
          <Grid item xs={12} sm={6}>
            <Box className="missionInfoItem">
              <Typography
                variant="body2"
                sx={{
                  color: "#6b7280",
                  fontSize: "12px",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Mission Order
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "var(--text-primary)",
                  fontWeight: 600,
                  fontSize: "18px",
                }}
              >
                {item?.order || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="missionInfoItem">
              <Typography
                variant="body2"
                sx={{
                  color: "#6b7280",
                  fontSize: "12px",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Judge
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "var(--text-primary)",
                  fontWeight: 600,
                  fontSize: "18px",
                  cursor: item?.judge?.id ? "pointer" : "auto",
                  textDecoration: item?.judge?.name ? "underline" : "none",
                }}
                onClick={() => {
                  if (item?.judge?.id) navigate(`/judges/${item?.judge?.id}`);
                }}
              >
                {item?.judge?.name || "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Scoring Report */}
          <Grid item xs={12}>
            <Box className="missionInfoItem">
              <Typography
                variant="body2"
                sx={{
                  color: "#6b7280",
                  fontSize: "12px",
                  marginBottom: "4px",
                  fontWeight: 500,
                }}
              >
                Scoring Report
              </Typography>
              {item?.scoringReportId ? (
                <Typography
                  variant="body1"
                  sx={{
                    color: "var(--primary)",
                    fontWeight: 500,
                    fontSize: "15px",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    navigate(
                      `/missions/${item?.id}/teams/${team?.id}/scoring-report/${item?.scoringReportId}`
                    )
                  }
                >
                  Show Report
                </Typography>
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: "var(--text-primary)",
                    fontWeight: 500,
                    fontSize: "15px",
                  }}
                >
                  No Report Yet
                </Typography>
              )}
            </Box>
          </Grid>

          {/* Submission */}
          <Grid item xs={12}>
            <Box className="missionInfoItem">
              <Typography
                variant="body2"
                sx={{
                  color: "#6b7280",
                  fontSize: "12px",
                  marginBottom: "8px",
                  fontWeight: 500,
                }}
              >
                Submission
              </Typography>
              {item?.submission?.missionTaskType == "mission" ? (
                item?.submission?.submittedFilePath ? (
                  <a
                    href={`${BaseURL}/${item?.submission?.submittedFilePath}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      padding: "8px 16px",
                      backgroundColor: "var(--primary)",
                      color: "var(--text-secondary)",
                      borderRadius: "6px",
                      textDecoration: "none",
                      fontWeight: 500,
                      fontSize: "14px",
                      transition: "opacity 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.9")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    Download Submission
                  </a>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 500,
                      fontSize: "15px",
                    }}
                  >
                    -
                  </Typography>
                )
              ) : item?.submission?.missionTaskType == "mcq" ? (
                item?.submission ? (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                    }}
                  >
                    <PrimaryButton
                      text={"Show Submission"}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "5px",
                        color: "var(--text-secondary)",
                        backgroundColor: "var(--primary)",
                        height: "35px",
                        padding: "0 15px",
                        minWidth: "120px",
                        textWrap: "noWrap",
                      }}
                      click={() => {
                        navigate(
                          `/missions/${item?.id}/teams/${team?.id}/submission/${item?.submission?.mcqTeamSubmissionId}`
                        );
                      }}
                    />
                    {item?.submission?.deletable && (
                      <DeleteForm
                        text={"Delete Submission"}
                        smallButton
                        padding={"0 15px"}
                        margin={"0"}
                        title={`Are you sure to delete the submission of ${team?.name} team ?`}
                        setGo={() => {
                          setGoDelete(true);
                        }}
                      />
                    )}
                  </Box>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 500,
                      fontSize: "15px",
                    }}
                  >
                    -
                  </Typography>
                )
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: "var(--text-primary)",
                    fontWeight: 500,
                    fontSize: "15px",
                  }}
                >
                  -
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            marginTop: "12px",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={submissionStatus == item?.id}
                onChange={(e) => {
                  setSubmissionStatus(
                    submissionStatus == item?.id ? null : item?.id
                  );
                  setGoEdit(true);
                }}
                color="primary"
              />
            }
            label="Force Submission"
            style={{
              margin: "0",
              color: "var(--text-primary)",
            }}
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <PrimaryButton
              classBtn={"center"}
              text={"See More"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--primary)",
                height: "35px",
                padding: "0 10px",
                minWidth: "100px",
                textWrap: "noWrap",
              }}
              click={() => navigate(`/missions/${item?.id}`)}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

function TeamsDetails({
  team,
  loading,
  setGo,
  missions,
  missionsLoading,
  awards,
  awardsLoading,
  submissionStatus,
  setSubmissionStatus,
  goEdit,
  setGoEdit,
}) {
  return (
    <div className="mainContainer">
      {team && !loading ? (
        <div className="TeacherCont">
          <div className="greyBox">
            <Grid container spacing={1}>
              {/* Basic Information Section */}
              <Grid item xs={12}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">Basic Information</h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Team Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Team Code
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.code || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Team Password
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.submissionPassword || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Account Code
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.account?.code || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Category Information Section */}
              <Grid item xs={12} sm={5}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">
                      Category Information
                    </h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Category
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.category?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Age Group
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.category?.ageGroup?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Coach Information Section */}
              <Grid item xs={12} sm={7}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">Coach Information</h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={4}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Coach Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.coach?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Coach Phone Number
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.coach?.contactNumber || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Organization Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {team?.account?.organizationName || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            <div style={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "column" },
                  width: "100%",
                }}
              >
                <h2 style={{ marginTop: "20px" }}>Team Members:</h2>
                <TableContainer
                  component={Paper}
                  sx={{
                    marginTop: "10px",
                  }}
                >
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">name</StyledTableCell>
                        <StyledTableCell align="center">
                          Birthday
                        </StyledTableCell>
                        <StyledTableCell align="center">Age</StyledTableCell>
                        <StyledTableCell align="center">
                          National ID
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {team?.members?.map((stu) => (
                        <StyledTableRow key={stu.name}>
                          <StyledTableCell align="center">
                            {stu.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {stu?.birthday?.split("T")?.at(0)}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {stu?.age}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {stu?.nationalId}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </div>
          </div>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <h2>Missions:</h2>
          </Box>
          {missions?.length && !missionsLoading ? (
            <Grid container spacing={2}>
              {missions?.map((item) => (
                <MissionItem
                  key={item?.id}
                  item={item}
                  team={team}
                  setSubmissionStatus={setSubmissionStatus}
                  setGoEdit={setGoEdit}
                  submissionStatus={submissionStatus}
                />
              ))}
            </Grid>
          ) : (
            <div>
              <h4 style={{ textAlign: "center" }}>No Missions Added Yet..</h4>
            </div>
          )}

          {/* <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            <h2>Special Awards Ranking:</h2>
          </Box>
          {awards?.length && !awardsLoading ? (
            <>
              <TableContainer
                component={Paper}
                sx={{
                  margin: "20px 0",
                }}
              >
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center">
                        Award Name
                      </StyledTableCell>
                      <StyledTableCell align="center">Score</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {awards?.map((team, i) => (
                      <StyledTableRow key={i}>
                        <StyledTableCell align="center">
                          {team?.award}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {team?.score}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )} */}
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default TeamsDetails;
